import type { HoleRange } from '@/lib/db/types';

interface Props {
  value: HoleRange;
  onChange: (holes: HoleRange) => void;
  compact?: boolean;
}

export function HolesSelector({ value, onChange, compact }: Props) {
  const options: { id: HoleRange; label: string }[] = compact
    ? [
        { id: 'full', label: '18' },
        { id: 'front-9', label: 'F9' },
        { id: 'back-9', label: 'B9' },
      ]
    : [
        { id: 'full', label: '18' },
        { id: 'front-9', label: 'Front 9' },
        { id: 'back-9', label: 'Back 9' },
      ];

  return (
    <div className="flex gap-2">
      {options.map((h) => (
        <button
          key={h.id}
          type="button"
          onClick={() => onChange(h.id)}
          className={`flex-1 rounded-lg py-2 text-sm font-semibold ${
            value === h.id ? 'bg-navy text-cream' : 'border border-line bg-paper'
          }`}
        >
          {h.label}
        </button>
      ))}
    </div>
  );
}
